export const getTextFromReactNode = (node: unknown): string => {
  if (node === null || node === undefined) {
    return '';
  }

  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }

  if (Array.isArray(node)) {
    return node.map(getTextFromReactNode).join('');
  }

  if (
    typeof node === 'object' &&
    'props' in node &&
    node.props &&
    typeof node.props === 'object' &&
    'children' in node.props &&
    node.props.children
  ) {
    return getTextFromReactNode(node.props.children);
  }

  return '';
};
